<template>
  <v-dialog
    v-model="dialog"
    :class="
      $vuetify?.display?.lgAndUp
        ? 'align-center justify-center startNewInspectionLarge'
        : 'align-center justify-center startNewInspectionSmall'
    "
    persistent
    no-click-animation
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Start New Inspection</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="startNewInspectionForm" v-model="validStartNewInspection">
          <v-row>
            <v-col cols="12" class="pt-0 pb-4 startNewInspectionDatePicker">
              <LabelDatefield
                id="inspection_Start_Date"
                label="B.IE.02 Inspection Start Date"
                v-model="inspectionStartDate"
                class="pt-1"
                labelXl="6"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                isRequired
                :isEditable="true"
                :maxDate="new Date()"
              ></LabelDatefield>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0 pb-4 startNewInspectionDatePicker">
              <LabelDatefield
                id="inspection_End_Date"
                label="B.IE.03 Inspection End Date"
                v-model="inspectionEndDate"
                class="pt-1"
                :minDate="inspectionStartDate ? inspectionStartDate : new Date()"
                labelXl="6"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                textXl="6"
                textLg="6"
                textMd="6"
                textSm="6"
                :isEditable="true"
              ></LabelDatefield>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-4 pb-4">
              <LabelSelect
                id="sel_Team_Leader"
                labelXl="6"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                selectXl="6"
                selectLg="6"
                selectMd="6"
                selectSm="6"
                isRequired
                label="B.IE.04 NCBI (Team Leader)"
                :options="teamLeaders"
                :isEditable="true"
                v-model="teamLeader"
              ></LabelSelect>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-4">
              <v-row>
                <v-col cols="6" class="bold pt-2 d-flex"
                  ><v-label class="bold"><span>Inspection Types Performed:</span></v-label></v-col
                >
                <v-col cols="6" class="pt-1">
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="initial"
                        label="1 - Initial"
                        :showColon="false"
                        :isEditable="true"
                        v-model="initial"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="routine"
                        label="2 - Routine"
                        :showColon="false"
                        :isEditable="true"
                        v-model="routine"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="underwater"
                        label="3 - Underwater"
                        :showColon="false"
                        :isEditable="true"
                        v-model="underwater"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="nstm"
                        label="4 - NSTM"
                        :showColon="false"
                        :isEditable="true"
                        v-model="nstm"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="damage"
                        label="5 - Damage"
                        :showColon="false"
                        :isEditable="true"
                        v-model="damage"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="inDepth"
                        label="6 - In-Depth"
                        :showColon="false"
                        :isEditable="true"
                        v-model="inDepth"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="special"
                        label="7 - Special"
                        :showColon="false"
                        :isEditable="true"
                        v-model="special"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="service"
                        label="8 - Service"
                        :showColon="false"
                        :isEditable="true"
                        v-model="service"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="scourMonitoring"
                        label="9 - Scour Monitoring"
                        :showColon="false"
                        :isEditable="true"
                        v-model="scourMonitoring"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="problemArea"
                        label="P - Problem Area"
                        :showColon="false"
                        :isEditable="true"
                        v-model="problemArea"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="element"
                        label="E - Element"
                        :showColon="false"
                        :isEditable="true"
                        v-model="element"
                        @update:modelValue="updateSelections()"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12"
                      ><LabelCheckbox
                        :labelXl="7"
                        :labelLg="7"
                        :labelMd="9"
                        :labelSm="9"
                        id="qa"
                        label="Q - QA"
                        :showColon="false"
                        v-model="qa"
                        @update:modelValue="updateSelections()"
                        :indent="false"
                      ></LabelCheckbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="btn_Ok"
          variant="outlined"
          class="mx-5"
          :disabled="
            !validStartNewInspection ||
            (inspectionTypesPerformed.includes('4') && inspectionTypesPerformed.length == 1) ||
            inspectionTypesPerformed.length == 0 ||
            (inspectionTypesPerformed.includes('1') && inspectionTypesPerformed.includes('2'))
          "
          @click="newInspectionHandler"
        >
          Ok
        </v-btn>
        <v-btn id="btn_Cancel" variant="outlined" class="mx-5" @click="cancel"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref, nextTick, computed, watch } from "vue";
import { useInspectionStore } from "@/stores/inspection";
import { useConfigStore } from "@/stores/config";
import LabelDatefield from "@/components/common/LabelDatefield.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import { getStreamBedMaterialsArray } from "@/composables/keyFields.js";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import inspectionType from "@/data/inspectionType.js";
import { LOGGER } from "@/util/logger";
import { INSPECTION_TYPE_PERFORMED, CHECKBOX_VALUE } from "@/constants/Inspections";
import { clone } from "@/util/clone";
import { getISOFormattedDateNoTime, getFormattedDateStringNoTime } from "@/composables/dateField.js";
import { calculateNextInspType } from "@/composables/futureSchedule";

export default {
  name: "StartNewInspection",
  emits: ["startNewInspection"],

  setup(_, ctx) {
    const inspectionStore = useInspectionStore();
    const configStore = useConfigStore();
    let structure = computed(() => inspectionStore.selectedInspection);
    let startNewInspectionForm = ref();
    let validStartNewInspection = ref(true);
    let dialog = ref(false);
    const nstmSelected = computed(() => nstm.value == "1");
    let teamLeaders = computed(() => configStore.getTeamLeaders(structure.value, nstmSelected.value));
    let inspectionStartDate = ref(null);
    let inspectionEndDate = ref(null);
    let teamLeader = ref(null);
    let inspectionTypesPerformed = ref([]);
    let initial = ref("0");
    let nstm = ref("0");
    let underwater = ref("0");
    let routine = ref("0");
    let damage = ref("0");
    let inDepth = ref("0");
    let special = ref("0");
    let service = ref("0");
    let scourMonitoring = ref("0");
    let problemArea = ref("0");
    let element = ref("0");
    let qa = ref("0");

    const cancel = () => {
      closeDialog();
    };

    const closeDialog = () => {
      dialog.value = false;
    };

    const openDialog = () => {
      inspectionTypesPerformed.value = [];
      dialog.value = true;
      inspectionStartDate.value = null;
      inspectionEndDate.value = null;
      teamLeader.value = null;
      initial.value = "0";
      routine.value = "0";
      underwater.value = "0";
      nstm.value = "0";
      damage.value = "0";
      inDepth.value = "0";
      special.value = "0";
      service.value = "0";
      scourMonitoring.value = "0";
      problemArea.value = "0";
      element.value = "0";
      qa.value = "0";
      nextTick(() => {
        startNewInspectionForm.value.validate();
      });
    };
    function setInspection(obj) {
      for (let i in obj) {
        if (Array.isArray(obj[i])) {
          setInspection(obj[i]);
        } else if (obj[i] && Object.hasOwn(obj[i], "inspectionId")) {
          obj[i].inspectionId = structure.value.inspection.inspectionId;
        }
      }
    }
    const overallScourHoleChangedByUser = computed(() => {
      return inspectionStore.getOverallScourHoleChangedByUser;
    });
    const overallScourHoles = computed({
      get() {
        if (!structure.value.userInspection.scourCondRating && !overallScourHoleChangedByUser.value) {
          if (structure.value?.inspectionsUnderwater[0] == null) {
            return "";
          } else {
            let overallScourHoles = structure.value.inspectionsUnderwater[0].scourHole;
            for (let idx in structure.value?.inspectionsUnderwater) {
              if (
                Number.parseInt(structure.value.inspectionsUnderwater[idx].scourHole) <
                Number.parseInt(overallScourHoles)
              ) {
                overallScourHoles = structure.value.inspectionsUnderwater[idx].scourHole;
              }
            }
            return overallScourHoles;
          }
        } else {
          return structure.value.userInspection.scourCondRating;
        }
      },
    });
    const copyKeyFields = () => {
      let { inspection, userInspection, structureUnits, inspectionsUnderwater } = structure.value;
      structure.value.keyFields = {
        inspectionDate: inspection.inspectionDate,
        inspectionType: inspection.inspectionType,
        inspectionStatus: inspection.inspectionStatus,
        apprAlign: inspection.apprAlign,
        apprRoadCondRate: userInspection.apprRoadCondRate,
        apprSlabCondRate: userInspection.apprSlabCondRate,
        bearingConditionRating: userInspection.overallBearingCondRating,
        brInspectionFreq: inspection.brInspectionFreq,
        chanRating: inspection.chanRating,
        chanProtRating: userInspection.chanProtRating,
        condition: inspection.condition,
        culvRating: inspection.culvRating,
        dkRating: inspection.dkRating,
        deckWsCondRate: userInspection.deckWsCondRate,
        jointConditionRating: userInspection.overallJointCondRating,
        elInspectionDone: inspection.elInspectionDone,
        elInspectionFreq: inspection.elInspectionFreq,
        elInspectionReq: inspection.elInspectionReq,
        fcInspectionDone: inspection.fcInspectionDone,
        fcInspectionFreq: inspection.fcInspectionFreq,
        fcInspectionReq: inspection.fcInspectionReq,
        nbInspectionDone: inspection.nbInspectionDone,
        nstmCondition: userInspection.nstmCondition,
        osInspectionDone: inspection.osInspectionDone,
        osInspectionFreq: inspection.osInspectionFreq,
        osInspectionReq: inspection.osInspectionReq,
        overallScourHoles: overallScourHoles.value,
        railRating: inspection.railRating,
        scourCondRating: userInspection.scourCondRating,
        scourCritical: inspection.scourCritical,
        scourCriticalCat: inspection.scourCriticalCat,
        streamBedMaterials: getStreamBedMaterialsArray(structureUnits, inspectionsUnderwater),
        subRating: inspection.subRating,
        supRating: inspection.supRating,
        transRating: inspection.transRating,
        underwaterRating: userInspection.underwaterRating,
        uwInspectionDone: inspection.uwInspectionDone,
        uwInspectionFreq: inspection.uwInspectionFreqv,
        uwInspectionReq: inspection.uwInspectionReq,
        wateradeq: inspection.wateradeq,
      };
    };
    const setComments = () => {
      const commentTypes = ["479", "67", "79", "478"];
      const inspectionCommentsPrev = [];
      const inspectionComments = structure.value.inspectionComments;

      for (const type of commentTypes ?? []) {
        const index = inspectionComments.findIndex((a) => a.commentType === type);
        if (index !== -1) {
          inspectionCommentsPrev.push(inspectionComments[index]);
          inspectionComments.splice(index, 1);
        }
      }

      structure.value.inspectionCommentsPrev = inspectionCommentsPrev;
    };

    const updateDurations = (inspectionDate, lastInspectionDate) => {
      let gapInDays = Math.abs(inspectionDate - lastInspectionDate) / (1000 * 60 * 60 * 24);
      let gapInYears = gapInDays / 365;

      for (let prop in structure.value.inspectionConditionHist) {
        if (prop.endsWith("Duration")) {
          let currentDuration = structure.value.inspectionConditionHist[prop];
          let newDuration = currentDuration + gapInYears;
          structure.value.inspectionConditionHist[prop] = Math.round(newDuration * 10) / 10;
        }
      }
    };

    let organizations = computed(() => configStore.getOrganizations);

    let users = computed(() => configStore.getUsers);

    const updateInspectionOrganizationName = () => {
      let bpId = users.value.find((a) => a.userId == structure.value.inspection.inspectionUserId)?.bpId;
      if (bpId == null) {
        structure.value.userInspection.inspOrgName = "Penndot";
      } else {
        structure.value.userInspection.inspOrgName = organizations.value.find(
          (a) => a.organization.bpId == bpId,
        )?.organization?.bpName;
      }
    };

    const newInspectionHandler = () => {
      startNewInspectionForm.value
        .validate()
        .then(async () => {
          if (validStartNewInspection.value) {
            inspectionStore.setOverallScourHoleChangedByUser(false);
            copyKeyFields();
            structure.value.inspection.inspectionStatus = "1";
            const lastInspectionDate = structure.value.inspection.inspectionDate;
            updateDurations(inspectionStartDate.value, new Date(lastInspectionDate));
            structure.value.inspection.inspectionDate = getISOFormattedDateNoTime(inspectionStartDate.value);
            structure.value.userInspection.overallEndDate = getISOFormattedDateNoTime(inspectionEndDate.value);
            const nextInspNumber = Number.parseInt(structure.value.maxInspectionId) + 1;
            structure.value.inspection.inspectionId = nextInspNumber;

            structure.value.inspection.inspectionUserId = teamLeader.value;
            updateInspectionOrganizationName();
            if (
              structure.value.userInspection.recommendRatingReview == "1" &&
              ["3", "6"].includes(structure.value.userInspection.lrReviewAction)
            ) {
              structure.value.userInspection.lrReviewAction = "1";
            }

            structure.value.userInspection.newWs = "0";
            setComments();

            if (["1", "3", "6"].includes(structure.value.userInspection.lrReviewAction)) {
              structure.value.userInspection.recommendRatingReview = "0";
            }
            structure.value.userInspection.postReviewRec = "0";
            if (structure.value.scourComp != null) {
              structure.value.scourComp.scourCalculated = "0";
            }
            setInspection(structure.value);
            structure.value.snbiInspSchedule.inspectionId = structure.value.inspection.inspectionId;
            structure.value.inspection.inspectionType = handleSetPrimaryInspType();
            handleInspCondHistory();
            //set snbi_schedule intervals to 0 if -1 or blank.
            handleSnbiScheduleInterval();
            handleInspectionTypesPerformed();
            handleLegacyInspectionInterval();
            handleNextInspectionType();
            closeDialog();
            ctx.emit("startNewInspection");
          }
        })
        .catch((err) => LOGGER.logException(err));
    };
    const updateSelections = () => {
      inspectionTypesPerformed.value = [];
      if (initial.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.INITIAL);
      }
      if (routine.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.ROUTINE);
      }
      if (underwater.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.UNDERWATER);
      }
      if (nstm.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.NSTM);
      }
      if (damage.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.DAMAGE);
      }
      if (inDepth.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.IN_DEPTH);
      }
      if (special.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.SPECIAL);
      }
      if (service.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.SERVICE);
      }
      if (scourMonitoring.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.SCOUR_MONITORING);
      }
      if (problemArea.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.PROBLEM_AREA);
      }
      if (element.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.ELEMENT);
      }
      if (qa.value == CHECKBOX_VALUE.CHECKED) {
        inspectionTypesPerformed.value.push(INSPECTION_TYPE_PERFORMED.QA);
      }
    };
    const handleSetPrimaryInspType = () => {
      if (
        inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.ROUTINE) &&
        inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.UNDERWATER)
      ) {
        return "W";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.INITIAL)) {
        return "F";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.ROUTINE)) {
        return "R";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.SPECIAL)) {
        return "I";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.UNDERWATER)) {
        return "U";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.DAMAGE)) {
        return "B";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.IN_DEPTH)) {
        return "D";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.SCOUR_MONITORING)) {
        return "P";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.PROBLEM_AREA)) {
        return "P";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.ELEMENT)) {
        return "E";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.SERVICE)) {
        return "H";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.QA)) {
        return "M";
      }
    };
    const setRBM = (inSpecificReportGroup, snbiInspEventObject, inspType) => {
      if (
        inSpecificReportGroup &&
        [
          INSPECTION_TYPE_PERFORMED.ROUTINE,
          INSPECTION_TYPE_PERFORMED.UNDERWATER,
          INSPECTION_TYPE_PERFORMED.NSTM,
        ].includes(inspType)
      ) {
        snbiInspEventObject.rbm = "1";
      } else if (inSpecificReportGroup) {
        snbiInspEventObject.rbm = "N";
      }
      return snbiInspEventObject;
    };
    const handleInspectionTypesPerformed = () => {
      structure.value.inspection.nbInspectionDone = "0";
      structure.value.inspection.uwInspectionDone = "0";
      structure.value.inspection.fcInspectionDone = "0";
      structure.value.inspection.osInspectionDone = "0";
      structure.value.inspection.elInspectionDone = "0";
      structure.value.snbiInspEvents = [];
      let snbiInspEventMainObject = clone(inspectionType);
      let inSpecificReportGroup = false;
      if (["S1", "A1", "L1"].includes(structure.value.structureBridge.reportGroup)) {
        inSpecificReportGroup = true;
      } else {
        snbiInspEventMainObject.RBM = "N";
      }
      snbiInspEventMainObject.brkey = structure.value.structureBridge.brkey;
      snbiInspEventMainObject.inspectionId = structure.value.inspection.inspectionId;
      snbiInspEventMainObject.startDate = getISOFormattedDateNoTime(inspectionStartDate.value);
      snbiInspEventMainObject.endDate = getISOFormattedDateNoTime(inspectionEndDate.value);
      snbiInspEventMainObject.teamLeader = teamLeader.value;
      snbiInspEventMainObject.modDate = new Date().toISOString();
      setInspectionTypesPerformed(snbiInspEventMainObject, inSpecificReportGroup);
    };

    const setInspectionTypesPerformed = (snbiInspEventMainObject, inSpecificReportGroup) => {
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.INITIAL)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);
        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.INITIAL);
        snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.INITIAL;
        snbiInspEventObject.inspInterval = 0;
        snbiInspEventObject.dueDate = null;
        structure.value.snbiInspEvents.push(snbiInspEventObject);
        structure.value.inspection.nbInspectionDone = "1";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.ROUTINE)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);
        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.ROUTINE);
        snbiInspEventObject = handleRoutine(snbiInspEventObject);
        structure.value.snbiInspEvents.push(snbiInspEventObject);
        structure.value.inspection.nbInspectionDone = "1";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.UNDERWATER)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);
        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.UNDERWATER);

        snbiInspEventObject = handleUnderwater(snbiInspEventObject);
        structure.value.snbiInspEvents.push(snbiInspEventObject);
        structure.value.inspection.uwInspectionDone = "1";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.NSTM)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.NSTM);
        snbiInspEventObject = handleNSTM(snbiInspEventObject);
        structure.value.snbiInspEvents.push(snbiInspEventObject);
        structure.value.inspection.fcInspectionDone = "1";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.DAMAGE)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.DAMAGE);
        snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.DAMAGE;
        snbiInspEventObject.inspInterval = 0;
        snbiInspEventObject.dueDate = null;
        structure.value.snbiInspEvents.push(snbiInspEventObject);
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.IN_DEPTH)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.IN_DEPTH);
        snbiInspEventObject = handleInDepth(snbiInspEventObject);
        structure.value.snbiInspEvents.push(snbiInspEventObject);
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.SPECIAL)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.SPECIAL);
        snbiInspEventObject = handleOtherSpecial(snbiInspEventObject);

        structure.value.snbiInspEvents.push(snbiInspEventObject);
        structure.value.inspection.osInspectionDone = "1";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.SERVICE)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.SERVICE);
        snbiInspEventObject = handleService(snbiInspEventObject);
        structure.value.snbiInspEvents.push(snbiInspEventObject);
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.SCOUR_MONITORING)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(
          inSpecificReportGroup,
          snbiInspEventObject,
          INSPECTION_TYPE_PERFORMED.SCOUR_MONITORING,
        );
        snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.SCOUR_MONITORING;
        snbiInspEventObject.inspInterval = 0;
        snbiInspEventObject.dueDate = null;
        structure.value.snbiInspEvents.push(snbiInspEventObject);
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.PROBLEM_AREA)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(
          inSpecificReportGroup,
          snbiInspEventObject,
          INSPECTION_TYPE_PERFORMED.PROBLEM_AREA,
        );
        snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.PROBLEM_AREA;
        snbiInspEventObject.inspInterval = 0;
        snbiInspEventObject.dueDate = null;
        structure.value.snbiInspEvents.push(snbiInspEventObject);
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.ELEMENT)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.ELEMENT);
        snbiInspEventObject = handleElement(snbiInspEventObject);

        structure.value.snbiInspEvents.push(snbiInspEventObject);
        structure.value.inspection.elInspectionDone = "1";
      }
      if (inspectionTypesPerformed.value.includes(INSPECTION_TYPE_PERFORMED.QA)) {
        let snbiInspEventObject = clone(snbiInspEventMainObject);

        snbiInspEventObject = setRBM(inSpecificReportGroup, snbiInspEventObject, INSPECTION_TYPE_PERFORMED.QA);
        snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.QA;
        snbiInspEventObject.inspInterval = 0;
        snbiInspEventObject.dueDate = null;
        structure.value.snbiInspEvents.push(snbiInspEventObject);
      }
    };

    const handleInspCondHistory = () => {
      if (structure.value.inspectionConditionHist) {
        structure.value.inspectionConditionHist.aEndRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.apprAlignDurationChanges = 0;
        structure.value.inspectionConditionHist.apprRoadCondRateDurationChanges = 0;
        structure.value.inspectionConditionHist.apprSlabCondRateDurationChanges = 0;
        structure.value.inspectionConditionHist.aRailRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.chanRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.conditionDurationChanges = 0;
        structure.value.inspectionConditionHist.culvRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.deckGEOMDurationChanges = 0;
        structure.value.inspectionConditionHist.deckWsCondRateDurationChanges = 0;
        structure.value.inspectionConditionHist.dkRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.lowestConditionDurationChanges = 0;
        structure.value.inspectionConditionHist.nstmConditionDurationChanges = 0;
        structure.value.inspectionConditionHist.paintCondRateDurationChanges = 0;
        structure.value.inspectionConditionHist.paintExtentRateDurationChanges = 0;
        structure.value.inspectionConditionHist.railRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.scourCondRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.scourCriticalDurationChanges = 0;
        structure.value.inspectionConditionHist.subRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.supRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.transRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.underClrDurationChanges = 0;
        structure.value.inspectionConditionHist.underwaterRatingDurationChanges = 0;
        structure.value.inspectionConditionHist.waterAdeqDurationChanges = 0;
      } else {
        structure.value.inspectionConditionHist = {
          brkey: structure.value.structureBridge.brkey,
          inspectionId: structure.value.inspection.inspectionId,
          aEndRating: "",
          aEndRatingChangeDate: "",
          aEndRatingDuration: 0,
          apprAlign: "",
          apprAlignChangeDate: "",
          apprAlignDuration: 0,
          apprRoadCondRate: "",
          apprRoadCondRateChangeDate: "",
          apprRoadCondRateDuration: 0,
          apprSlabCondRate: "",
          apprSlabCondRateChangeDate: "",
          apprSlabCondRateDuration: 0,
          aRailRating: "",
          aRailRatingChangeDate: "",
          aRailRatingDuration: 0,
          chanRating: "",
          chanRatingChangeDate: "",
          chanRatingDuration: 0,
          condition: "",
          conditionChangeDate: "",
          conditionDuration: 0,
          culvRating: "",
          culvRatingChangeDate: "",
          culvRatingDuration: 0,
          deckgeom: "",
          deckGEOMChangeDate: "",
          deckGEOMDuration: 0,
          deckWsCondRate: "",
          deckWsCondRateChangeDate: "",
          deckWsCondRateDuration: 0,
          dkRating: "",
          dkRatingChangeDate: "",
          dkRatingDuration: 0,
          inspectionDate: structure.value.inspection.inspectionDate,
          lowestCondition: null,
          lowestConditionChangeDate: "",
          lowestConditionDuration: 0,
          nstmCondition: null,
          nstmConditionChangeDate: "",
          nstmConditionDuration: 0,
          paintCondRate: "",
          paintCondRateChangeDate: "",
          paintCondRateDuration: 0,
          paintExtentRate: "",
          paintExtentRateChangeDate: "",
          paintExtentRateDuration: 0,
          railRating: "",
          railRatingChangeDate: "",
          railRatingDuration: 0,
          scourCondRating: null,
          scourCondRatingChangeDate: "",
          scourCondRatingDuration: 0,
          scourCritical: "",
          scourCriticalChangeDate: "",
          scourCriticalDuration: 0,
          subRating: "",
          subRatingChangeDate: "",
          subRatingDuration: 0,
          supRating: "",
          supRatingChangeDate: "",
          supRatingDuration: 0,
          transRating: "",
          transRatingChangeDate: "",
          transRatingDuration: 0,
          underclr: "",
          underCLRChangeDate: "",
          underClrDuration: 0,
          underwaterRating: null,
          underwaterRatingChangeDate: "",
          underwaterRatingDuration: 0,
          waterAdeqDuration: 0,
          waterAdeq: "",
          waterAdeqChangeDate: "",

          aEndRatingDurationChanges: 1,
          apprAlignDurationChanges: 1,
          apprRoadCondRateDurationChanges: 1,
          apprSlabCondRateDurationChanges: 1,
          aRailRatingDurationChanges: 1,
          chanRatingDurationChanges: 1,
          conditionDurationChanges: 1,
          culvRatingDurationChanges: 1,
          deckGEOMDurationChanges: 1,
          deckWsCondRateDurationChanges: 1,
          dkRatingDurationChanges: 1,
          lowestConditionDurationChanges: 1,
          nstmConditionDurationChanges: 1,
          paintCondRateDurationChanges: 1,
          paintExtentRateDurationChanges: 1,
          railRatingDurationChanges: 1,
          scourCondRatingDurationChanges: 1,
          scourCriticalDurationChanges: 1,
          subRatingDurationChanges: 1,
          supRatingDurationChanges: 1,
          transRatingDurationChanges: 1,
          underClrDurationChanges: 1,
          underwaterRatingDurationChanges: 1,
          waterAdeqDurationChanges: 1,
        };
      }
    };

    const handleRoutine = (snbiInspEventObject) => {
      snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.ROUTINE;
      snbiInspEventObject.inspInterval = structure.value?.snbiInspSchedule?.rouInterval || 0;
      //set 7A60, 7A10
      snbiInspEventObject.dueDate =
        structure.value.snbiInspSchedule.rouNextDate =
        structure.value.inspection.nextInspection =
          setInspTypeDueDate(snbiInspEventObject);
      return snbiInspEventObject;
    };
    const handleUnderwater = (snbiInspEventObject) => {
      snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.UNDERWATER;
      snbiInspEventObject.inspInterval = structure.value?.snbiInspSchedule?.uwInterval || 0;
      snbiInspEventObject.dueDate =
        structure.value.snbiInspSchedule.uwNextDate =
        structure.value.inspection.uwNextDate =
          setInspTypeDueDate(snbiInspEventObject);
      return snbiInspEventObject;
    };
    const handleNSTM = (snbiInspEventObject) => {
      snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.NSTM;
      snbiInspEventObject.inspInterval = structure.value?.snbiInspSchedule?.nstmInterval || 0;
      snbiInspEventObject.dueDate =
        structure.value.snbiInspSchedule.nstmNextDate =
        structure.value.inspection.fcNextDate =
          setInspTypeDueDate(snbiInspEventObject);
      return snbiInspEventObject;
    };
    const handleInDepth = (snbiInspEventObject) => {
      snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.IN_DEPTH;
      snbiInspEventObject.inspInterval = structure.value?.snbiInspSchedule?.indInterval || 0;
      snbiInspEventObject.dueDate = structure.value.snbiInspSchedule.indNextDate =
        setInspTypeDueDate(snbiInspEventObject);
      return snbiInspEventObject;
    };
    const handleOtherSpecial = (snbiInspEventObject) => {
      snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.SPECIAL;
      snbiInspEventObject.inspInterval = structure.value?.snbiInspSchedule?.osInterval || 0;
      snbiInspEventObject.dueDate =
        structure.value.snbiInspSchedule.osNextDate =
        structure.value.inspection.osNextDate =
          setInspTypeDueDate(snbiInspEventObject);
      return snbiInspEventObject;
    };
    const handleService = (snbiInspEventObject) => {
      snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.SERVICE;
      snbiInspEventObject.inspInterval = structure.value?.snbiInspSchedule?.servInterval || 0;
      snbiInspEventObject.dueDate = structure.value.snbiInspSchedule.servNextDate =
        setInspTypeDueDate(snbiInspEventObject);
      return snbiInspEventObject;
    };
    const handleElement = (snbiInspEventObject) => {
      snbiInspEventObject.inspType = INSPECTION_TYPE_PERFORMED.ELEMENT;
      snbiInspEventObject.inspInterval = structure.value?.snbiInspSchedule?.elemInterval || 0;
      snbiInspEventObject.dueDate =
        structure.value.snbiInspSchedule.elemNextDate =
        structure.value.inspection.elNextDate =
          setInspTypeDueDate(snbiInspEventObject);
      return snbiInspEventObject;
    };
    const handleSnbiScheduleInterval = () => {
      for (const key of Object.keys(structure.value.snbiInspSchedule)) {
        if (key.endsWith("_INTERVAL")) {
          structure.value.snbiInspSchedule[key] = getInterval(structure.value.snbiInspSchedule[key]);
        }
      }
    };
    const handleLegacyInspectionInterval = () => {
      structure.value.inspection.brInspectionFreq = getInterval(structure.value?.inspection?.brInspectionFreq);
      structure.value.inspection.fcInspectionFreq = getInterval(structure.value?.inspection?.fcInspectionFreq);
      structure.value.inspection.uwInspectionFreq = getInterval(structure.value?.inspection?.uwInspectionFreq);
      structure.value.inspection.osInspectionFreq = getInterval(structure.value?.inspection?.osInspectionFreq);
      structure.value.inspection.elInspectionFreq = getInterval(structure.value?.inspection?.elInspectionFreq);
    };

    const handleNextInspectionType = () => {
      const inspTypesMap = [
        { dateKey: "rouNextDate", inspType: "2" },
        { dateKey: "uwNextDate", inspType: "3" },
        { dateKey: "nstmNextDate", inspType: "4" },
        { dateKey: "indNextDate", inspType: "6" },
        { dateKey: "osNextDate", inspType: "7" },
        { dateKey: "servNextDate", inspType: "8" },
        { dateKey: "elemNextDate", inspType: "E" },
      ];

      const arrayForRecalc = inspTypesMap.map(({ dateKey, inspType }) => ({
        inspectionDueDate: structure.value.snbiInspSchedule[dateKey],
        inspType,
      }));
      structure.value.userInspection.nextInspType = calculateNextInspType(arrayForRecalc);
    };

    const getInterval = (value) => {
      return value == -1 || !value ? 0 : value;
    };

    const setInspTypeDueDate = (detail) => {
      if (detail.endDate && detail.inspInterval > 0 && !["Z", "1", "5", "9", "P", "Q"].includes(detail.inspType)) {
        let endDateValue = new Date(getFormattedDateStringNoTime(detail.endDate));
        let day = endDateValue.getDate();
        const calculatedDueDate = new Date(endDateValue.setMonth(endDateValue.getMonth() + detail.inspInterval));
        if (calculatedDueDate.getDate() !== day) {
          //we crossed the month boundary
          calculatedDueDate.setDate(0); //set to the last day of previous month
        }
        return getISOFormattedDateNoTime(calculatedDueDate);
      } else {
        return null;
      }
    };

    watch(
      () => [nstm.value],
      () => {
        if (nstm.value) {
          //check if the selected team leader is in the nstm team leaders with certs list
          if (!teamLeaders.value?.some((leader) => teamLeader.value == leader?.value)) {
            //if not in the list set the selected value to null
            teamLeader.value = null;
          }
        }
        startNewInspectionForm.value.validate();
      },
      { deep: true },
    );

    return {
      updateSelections,
      inspectionTypesPerformed,
      element,
      initial,
      routine,
      damage,
      inDepth,
      special,
      service,
      scourMonitoring,
      problemArea,
      qa,
      underwater,
      nstm,
      teamLeader,
      inspectionEndDate,
      inspectionStartDate,
      validStartNewInspection,
      startNewInspectionForm,
      teamLeaders,
      REFERENCE_TABLE,
      dialog,
      openDialog,
      structure,
      open,
      newInspectionHandler,
      cancel,
      closeDialog,
    };
  },
  components: {
    LabelSelect,
    LabelCheckbox,
    LabelDatefield,
  },
};
</script>
